import { Collection } from '../../shared/constants';
import { getAllDocsByRevendaId } from './collectionBaseWorker';

export const getLastTerms = async ({ revendaId }) => {
    return await getAllDocsByRevendaId({ collection: Collection.TERMS, revendaId: revendaId })
}